/** Extrait le texte brut d'un contenu ProseMirror/TipTap. */
export const richTextToPlain = (node: unknown): string => {
  if (!node || typeof node !== "object") return "";
  const n = node as { type?: string; text?: string; content?: unknown[] };
  if (typeof n.text === "string") return n.text;
  const children = Array.isArray(n.content)
    ? n.content.map(richTextToPlain)
    : [];
  const joined = children.join("");
  const blockTypes = new Set([
    "paragraph",
    "heading",
    "listItem",
    "bulletList",
    "orderedList",
    "blockquote",
    "hardBreak",
  ]);
  if (n.type && blockTypes.has(n.type)) {
    return joined + "\n";
  }
  return joined;
};
